import { render, staticRenderFns } from "./AdvertisingModal.vue?vue&type=template&id=a31fe03c&"
import script from "./AdvertisingModal.vue?vue&type=script&lang=js&"
export * from "./AdvertisingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports